export const PageSelectorServiceSymbol = Symbol.for('PageSelectorService');
